/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { differenceInDays } from 'date-fns';
import Helper from '../../../../state/reducers/Helper';
import { DDMMMYY } from '../../../../utils/dateString';

const noDLCFList = [
    'never delivered',
    'No, I need additional help.',
];

const list1 = [
    'never delivered',
    'delivered late',
    'delivered too early',
    "doesn't look like picture",
    'wrong item delivered',
    'delivered damaged, broken and/or spoiled',
];

const list2 = [
    'primary item (flower, plants, gifts)',
    'container (vase, pot, basket)',
    'food (chocolate, fruit, cheese)',
    'add-ons (plush, balloon, pretzels)',
];

const list3 = [
    'unopened blooms',
    'dead, wilted, or dry',
    'did not last',
    'frozen',
    'soiled',
];

const list4 = [
    'sounds great. Let\'s do it.',
    'No, I need additional help.',
];

const list5 = [ // No, I need additional help. for floral brand
    'issue a 50% refund, and a $15 Savings Pass credit.',
    'chat with a live agent now.',
];

const list6 = [ // Container (vase, pot, basket)
    'broken',
    'leaking',
    'damaged',
    'dirty/Stained',
];

const list7 = [ // "doesn't look like picture" && Container (vase, pot, basket)
    'wrong color',
    'missing item',
];

const list8 = [ // Food (chocolate, fruit, cheese)
    'broken/Melted',
    'expired',
    'frozen',
    'not fresh',
];

const list9 = [ // GPT product && not expired
    'yes',
    'no',
];

const list10 = [
    'unsatisfactory flower substitution',
    'wrong color substitution',
    'missing item',
    'incorrect quantity',
    'incorrect arrangement',
    'wrong size',
];

const list11 = [
    'missing item',
    'wrong item',
];

const list12 = [
    'primary item (flower, plants, gifts)',
    'container (vase, pot, basket)',
    'food (chocolate, fruit, cheese)',
    'card message',
    'add-ons (plush, balloon, pretzels)',
];

const list13 = [
    'sounds great. Let\'s do it.',
    'chat with a live agent now.',
];

const list14 = [ // No, I need additional help. for food brand
    'issue a full refund.',
    'chat with a live agent now.',
];

const list15 = [ // 'doesn't look like picture'. for food brand
    'primary item (flowers, plants, gift baskets, gifts)',
    'container (vase, pot, basket)',
    'food (food gift baskets, chocolate, fruit, cheese, wine)',
    'add-ons (wine, cider, chocolate, Moose Munch)',
];

const list16 = [ // for food brand
    'unsatisfactory substitution',
    'missing item',
    'incorrect quantity',
];

const list17 = [ // for food brand
    'unsatisfactory substitution',
    'missing item',
    'wrong color',
];

const list18 = [ // for food brand
    'unsatisfactory substitution',
    'missing item',
    'wrong item',
];

const list19 = [ // for food brand
    'primary item (flowers, plants, gift baskets, gifts)',
    'food (food gift baskets, chocolate, fruit, cheese, wine)',
    'gift message',
    'add-ons (wine, cider, chocolate, Moose Munch)',
];

const list20 = [ // for food brand - quality issue - primary
    'unopened blooms',
    'dead, wilted, or dry',
    'frozen',
    'soiled',
    'broken or damaged',
];

const list21 = [ // for food brand - quality issue - food
    'expired',
    'frozen',
    'spoiled',
    'melted',
];

const list22 = [ // for food brand - quality issue - container
    'broken or damaged',
    'leaking',
];

const list23 = [ // for food brand - quality issue - addons
    'broken or damaged',
    'spoiled',
    'melted',
];

const list24 = [ // for food brand - delivered too early - need additional help
    'redeliver the item for the requested date',
    'chat with live agent now',
];

const handleResolutionSelection = (page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType) => {
    let resolution = '';
    let reason = '';
    let item = '';
    let condition = '';
    let shippingBoxDamaged = false;

    if (page3ReasonType === 'sounds great. Let\'s do it.' || page4ReasonType === 'sounds great. Let\'s do it.') {
        resolution = 'replacement';
    } else if (page3ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.' || page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.' || page5ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
        resolution = 'partialRefund';
    } else if (page3ReasonType === 'issue a full refund.' || page4ReasonType === 'issue a full refund.' || page5ReasonType === 'issue a full refund.') {
        resolution = 'refund'; // only for food brands
    }

    if (page0ReasonType === 'never delivered' || page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') {
        reason = 'Delivery Issue';
    } else if (['doesn\'t look like picture', 'wrong item delivered'].includes(page0ReasonType)) {
        reason = 'Delivered Wrong';
    } else if (page0ReasonType === 'delivered damaged, broken and/or spoiled') {
        reason = 'Quality Issue';
    }

    if (page1ReasonType === 'primary item (flower, plants, gifts)' || page1ReasonType === 'primary item (flowers, plants, gift baskets, gifts)') {
        item = 'Primary';
    } else if (page1ReasonType === 'container (vase, pot, basket)') {
        item = 'Container';
    } else if (page1ReasonType === 'food (chocolate, fruit, cheese)' || page1ReasonType === 'food (food gift baskets, chocolate, fruit, cheese, wine)') {
        item = 'Food';
    } else if (page1ReasonType === 'add-ons (plush, balloon, pretzels)' || page1ReasonType === 'add-ons (wine, cider, chocolate, Moose Munch)') {
        item = 'Addon';
    }

    if (page2ReasonType === 'unopened blooms') {
        condition = 'Unopened Blooms';
    } else if (page2ReasonType === 'dead, wilted, or dry') {
        condition = 'Dead Wilted Dry';
    } else if (page2ReasonType === 'frozen') {
        condition = 'Frozen';
    } else if (page2ReasonType === 'soiled') {
        condition = 'soiled';
    } else if (page2ReasonType === 'dirty/Stained') {
        condition = 'Dirty Stained';
    } else if (page2ReasonType === 'broken') {
        condition = 'Broken';
    } else if (page2ReasonType === 'broken/Melted') {
        condition = 'Broken Melted';
    } else if (page2ReasonType === 'expired') {
        condition = 'Expired';
    } else if (page2ReasonType === 'not fresh') {
        condition = 'Not Fresh';
    } else if (page2ReasonType === 'did not last') {
        condition = 'Did Not Last';
    } else if (page2ReasonType === 'wrong color') {
        condition = 'Wrong Color';
    } else if (page2ReasonType === 'missing item') {
        condition = 'Missing Item';
    } else if (page2ReasonType === 'incorrect arrangement') {
        condition = 'Incorrect Arrangement';
    } else if (page2ReasonType === 'wrong color substitution') {
        condition = 'Wrong Color Substitution';
    } else if (page2ReasonType === 'wrong size') {
        condition = 'Wrong Size';
    } else if (page2ReasonType === 'wrong item') {
        condition = 'Wrong Item';
    }

    if (page3ReasonType === 'yes' && page0ReasonType === 'delivered damaged, broken and/or spoiled') {
        shippingBoxDamaged = true;
    }
    return {
        resolution, reason, item, condition, shippingBoxDamaged,
    };
};

const checkIsMoreThan7Days = (deliveryDate) => {
    const todaysDate = new Date().toISOString().substring(0, 10);
    const parsedTodaysDate = todaysDate.split('-');
    const parsedDeliveryDate = deliveryDate.split('-');
    return differenceInDays(
        new Date(parsedTodaysDate[0], parsedTodaysDate[1], parsedTodaysDate[2]),
        new Date(parsedDeliveryDate[0], parsedDeliveryDate[1], parsedDeliveryDate[2]),
    ) >= 7;
};

const handleResCode = (isMoreThan7Days, itemType, reason, shippingBoxDamaged, item, condition, isItemDLC) => {
    const resCode = 0;
    const isFPT = itemType === 'FPT';
    const isGPT = itemType === 'GPT';

    // @itemType - 'FPT' or 'GPT'
    // @reason - 'Quality Issue' or 'Delivered Wrong' or 'Delivery Issue'...
    //    - Can be determined using screen1 selection (Delivered damaged, broken, and/or spoiled = Quality Issue)
    // @condition - Dead, wilted, or dry​ or Broken or Expired etc...
    // @item - Container, Food, Primary etc..
    // @isItemDLC  (is item delivered) - Ross order status = 'DELIVERED'

    // NOTES:
    //    example:
    //    res_code: 276
    //       - suggested_res_code for Replacement = EG
    //       - suggested_res_code for Replacement = PG
    //    Payload for this res code stays the same - only suggested_res_code changes.

    if (reason === 'Quality Issue') {
        if (item === 'Primary') {
            if (condition === 'Dead Wilted Dry') {
                if (isFPT) { return isMoreThan7Days ? 278 : 276; }
                if (isGPT) { return shippingBoxDamaged ? 280 : 278; }
            } else if (condition === 'Unopened Blooms') {
                if (isFPT) { return 260; }
                if (isGPT) { return 262; }
            } else if (condition === 'Did Not Last') {
                if (isFPT) { return isMoreThan7Days ? 284 : 282; }
                if (isGPT) { return isMoreThan7Days ? 284 : 286; }
            } else if (condition === 'Frozen') {
                if (isFPT) { return 290; }
                if (isGPT) { return 290; }
            }
        } else if (item === 'Container') {
            if (condition === 'Broken') {
                if (isFPT) { return 234; }
                if (isGPT) { return shippingBoxDamaged ? 236 : 238; }
            } else if (condition === 'Dirty Stained') {
                if (isFPT) { return 254; }
                if (isGPT) { return shippingBoxDamaged ? 256 : 258; }
            }
        } else if (item === 'Food') {
            if (condition === 'Broken Melted') {
                if (isFPT) { return 314; }
                if (isGPT) { return shippingBoxDamaged ? 316 : 318; }
            } else if (condition === 'Not Fresh') {
                if (isFPT) { return 334; }
                if (isGPT) { return 336; }
            } else if (condition === 'Expired') {
                if (isFPT) { return 320; }
                if (isGPT) { return 322; }
            }
        }
    } else if (reason === 'Delivered Wrong') {
        // What does on or after delivery date mean? Different than 7 days or longer after delivery date?
        // Do we need to add a condiiton for this? line 110 - 111, 114 - 115, 118-119  in Replacement Flow spreadsheet
        if (item === 'Primary') {
            if (condition === 'Incorrect Arrangement') {
                if (isFPT) { return 398; }
                if (isGPT) { return 399; }
            } else if (condition === 'Missing Item' || condition === 'Wrong Size') {
                if (isFPT) { return 409; }
                if (isGPT) { return 410; }
            } else if (condition === 'Wrong Color Substitution') { // TODO: Do we need to move it to container part same as we are having for FPT?
                if (isFPT) { return 405; }
                if (isGPT) { return 406; }
            }
        } else if (item === 'Container') {
            if (condition === 'Broken') { if (isFPT) { return 234; } } else if (condition === 'Dirty Stained') { if (isFPT) { return 254; } } else if (condition === 'Wrong Color') {
                if (isFPT) { return 382; }
                if (isGPT) { return 383; }
            } else if (condition === 'Missing Item') {
                if (isFPT) { return 389; }
                if (isGPT) { return 390; }
            } else if (condition === 'Wrong Color Substitution') {
                if (isFPT) { return 405; }
            }
        } else if (item === 'Food') {
            if (condition === 'Missing Item' || condition === 'Wrong Item') {
                if (isFPT) { return 432; }
                if (isGPT) { return 433; }
            }
        }
    } else if (reason === 'Delivery Issue') {
        // DLC means status = DELIVERED
        // No DLC means status = IN TRANSIT
        // What does After delivery date mean?
        // We need to add a check for this - line 158-159, 163-164 in Replacement Flow spreadsheet
        if (isFPT) { return isItemDLC ? 178 : 176; }
        if (isGPT) { return isItemDLC ? 178 : 155; }
    }
    return resCode;
};

const renderButtonText = (currentSelectedRadio, isQualityIssueChatFlowEnabled, productBrand, isHDReplacementRoutingToAgent = false, noDLCF = false) => {
    const listOfRadiosForSubmitBtn = [
        'issue a 50% refund, and a $15 Savings Pass credit.',
        'sounds great. Let\'s do it.',
        'issue a full refund.',
    ];
    if (
        ((isHDReplacementRoutingToAgent && Helper.isFoodBrand(productBrand) && ['sounds great. Let\'s do it.'].includes(currentSelectedRadio))
       || (isQualityIssueChatFlowEnabled && currentSelectedRadio?.includes('delivered damaged') && Helper.isFloralBrand(productBrand)))
       || (isQualityIssueChatFlowEnabled && currentSelectedRadio?.includes('delivered damaged') && Helper.isFoodBrand(productBrand))
       || currentSelectedRadio?.includes('chat with a live agent now.')
       || ['card message', 'add-ons (plush, balloon, pretzels)'].includes(currentSelectedRadio)
       || (['No, I need additional help.'].includes(currentSelectedRadio) && noDLCF) // pop chat for noDLCF
    ) {
        return 'Chat with agent';
    }
    return listOfRadiosForSubmitBtn.includes(currentSelectedRadio) ? 'Submit' : 'Next';
};

const generateAgentMessage = (isChatRadioSelected, reasonTypes = {}) => {
    const {
        page0ReasonType,
        page1ReasonType,
        page2ReasonType,
        page3ReasonType,
        page4ReasonType,
        page5ReasonType,
    } = reasonTypes;
    let agentMessage = '';
    if (isChatRadioSelected && page3ReasonType === 'sounds great. Let\'s do it.') {
        agentMessage = 'Customer wants: redelivery of the same item';
    } else if (isChatRadioSelected && page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
        agentMessage = 'Customer wants: partial refund';
    } else if (isChatRadioSelected && (page4ReasonType === 'issue a full refund.' || page5ReasonType === 'issue a full refund.')) {
        agentMessage = 'Customer wants: full refund';
    } else {
        agentMessage = (
            `${
            (page0ReasonType ? `${agentMessage  }${page0ReasonType}` : `${agentMessage  }`)
            + (page1ReasonType ? `${agentMessage  } | ${page1ReasonType}` : `${agentMessage  }`)
            + (page2ReasonType ? `${agentMessage  } | ${page2ReasonType}` : `${agentMessage  }`)
            + (page3ReasonType ? `${agentMessage  } | ${page3ReasonType}` : `${agentMessage  }`)
            + (page4ReasonType ? `${agentMessage  } | ${page4ReasonType}` : `${agentMessage  }`)
            + (page5ReasonType ? `${agentMessage  } | ${page5ReasonType}` : `${agentMessage  }`)
        }`);
    }
    return agentMessage;
};

const generateResCodePayload = (resCode, resolution, ROSSOrderNumber, productType, tiEmail, startTime, ssrDeviceType, resolutionBrand, noDLCF, user) => {
    const deviceType = ssrDeviceType;
    const [suggestResCode, suggestedResId] = resolution === 'replacement' ? ['EG', '312'] : ['PG', '322'];

    switch (resCode) {
        // Delivery Issue Not Received Item Left on Truck - GPT - After delivery date (No DLC)
        case 155:
            return {
                orderNumber: ROSSOrderNumber,
                user,
                noDLCF,
                ti_email: tiEmail,
                start_time: startTime,
            };
            // Delivery Issue Not Received Recipient Confirms Not Received FPT - After delivery date (No DLC)
        case 176:
            return {
                orderNumber: ROSSOrderNumber,
                user,
                noDLCF,
                ti_email: tiEmail,
                start_time: startTime,
            };
            // Delivery Issue Not Received Recipient Confirms Not Received FPT - After delivery date (With DLC)
        case 178:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'N',
                detail_code: 'NR',
                reason_code: 'RCN',
                res_code: '178',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'L',
                error_code: 'D',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container/Vase/Basket/Bag Broken/Torn FPT
        case 234:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'BKT',
                res_code: '234',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container Broken GPT - box damaged
        case 236:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'BTD',
                res_code: '236',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'H',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container Broken GPT - box not damaged
        case 238:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'BTN',
                res_code: '238',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container Dirty/Stained FPT
        case 254:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'SDY',
                res_code: '254',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container Dirty/Stained GPT - box damaged
        case 256:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'SDD',
                res_code: '256',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'H',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Container Dirty/Stained GPT - box not damaged
        case 258:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'CN',
                reason_code: 'SDN',
                res_code: '258',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Blooms Did Not Open - FPT
        case 260:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'BNO',
                res_code: '260',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Blooms Did Not Open - GPT
        case 262:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'BNO',
                res_code: '262',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Broken Heads/Stems - FPT
        case 264:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'BHS',
                res_code: '264',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Broken Heads/Stems - GPT
        case 268:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'BHN',
                res_code: '268',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers/Plants Dead/Wilted/Dry FPT - Less than 7 Days
        case 276:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'DWD',
                res_code: '276',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers/Plants Dead/Wilted/Dry FPT - 7 Days or more
        case 278:
            if (productType === 'FPT') {
                return {
                    deviceType,
                    orderNumber: ROSSOrderNumber,
                    user,
                    ti_email: tiEmail,
                    start_time: startTime,
                    resolution_brand: resolutionBrand,
                    msg_florist: 'N',
                    problem_code: 'Q',
                    detail_code: 'FP',
                    reason_code: 'DWD',
                    res_code: '278',
                    suggest_res_code: suggestResCode,
                    status_code: 'X',
                    fault_code: 'L',
                    error_code: 'P',
                    suggested_res_id: suggestedResId,
                };
            } if (productType === 'GPT') {
            // Quality Issue Flowers/Plants Dead/Wilted/Dry GPT less than 7 days  - box not damaged
                return {
                    deviceType,
                    orderNumber: ROSSOrderNumber,
                    user,
                    ti_email: tiEmail,
                    start_time: startTime,
                    resolution_brand: resolutionBrand,
                    msg_florist: 'N',
                    problem_code: 'Q',
                    detail_code: 'FP',
                    reason_code: 'DWD',
                    res_code: '278',
                    suggest_res_code: suggestResCode,
                    status_code: 'X',
                    fault_code: 'L',
                    error_code: 'P',
                    suggested_res_id: suggestedResId,
                };
            }
            break;
            // Quality Issue Flowers/Plants Dead/Wilted/Dry GPT - box damaged
        case 280:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'DWD',
                res_code: '280',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Did Not Last - FPT (Less than 7 Days)
        case 282:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'DNL',
                res_code: '282',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Did Not Last - *FPT or GPT* (Greater than 7 days)
        case 284:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'DNL',
                res_code: '284',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'L',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Did Not Last - GPT (Less than 7 days)
        case 286:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'DNL',
                res_code: '286',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Frozen - FPT
        case 290:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'FRE',
                res_code: '290',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Overall Quality (Low Perceived Value) - FPT
        case 294:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'LPV',
                res_code: '294',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Overall Quality (Low Perceived Value) - GPT
        case 296:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'LPV',
                res_code: '296',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Molded / Spotted / Brown - FPT
        case 298:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'MSB',
                res_code: '298',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Flowers / Plants Molded / Spotted / Brown - GPT
        case 300:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FP',
                reason_code: 'MSB',
                res_code: '300',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Broken/Melted FPT
        case 314:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'BKT',
                res_code: '314',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Broken/Melted GPT - box damaged
        case 316:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'BTD',
                res_code: '316',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'H',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Broken/Melted GPT - box not damaged
        case 318:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'BTN',
                res_code: '318',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Date Expired FPT
        case 320:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'EXP',
                res_code: '320',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Date Expired GPT
        case 322:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'EXP',
                res_code: '322',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Low perceived Value FPT
        case 330:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'LPV',
                res_code: '330',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Low perceived Value GPT
        case 332:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'LPV',
                res_code: '332',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Not Fresh FPT
        case 334:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'NSM',
                res_code: '334',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Quality Issue Food Not Fresh GPT
        case 336:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'Q',
                detail_code: 'FF',
                reason_code: 'NSM',
                res_code: '336',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Delivered Wrong Container Color - FPT - On or After delivery date
        case 382:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'CN',
                reason_code: 'CLR',
                res_code: '382',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Delivered Wrong Container Color - GPT - On or After delivery date
        case 383:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'CN',
                reason_code: 'CLR',
                res_code: '383',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Delivered Wrong Container Missing - FPT - On or After delivery date
        case 389:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'CN',
                reason_code: 'MNA',
                res_code: '389',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Container Missing - GPT - On or After delivery date "
        case 390:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'CN',
                reason_code: 'MNA',
                res_code: '390',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers/Plants Arrangement - FPT - On or After delivery date "
        case 398:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'ARN',
                res_code: '398',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers / Plants Arrangement - GPT - On or After delivery date"
            // Note this flow does not exist for partial credit on the SC side
        case 399:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'ARN',
                res_code: '399',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers / Plants Arrangement - GPT - On or After delivery date "
        case 401:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'ARN',
                res_code: '401',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers/Plants Color - FPT - On or After delivery date "
        case 405:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'CLR',
                res_code: '405',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers / Plants Color - GPT - On or After delivery date "
        case 406:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'CLR',
                res_code: '406',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers/Plants Incomplete / Missing / Size - FPT - On or After delivery date "
        case 409:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'IMS',
                res_code: '409',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Flowers / Plants Incomplete / Missing / Size - GPT - On or After delivery date "
        case 410:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'FP',
                reason_code: 'IMS',
                res_code: '410',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // Delivered Wrong Food Incomplete - FPT - On or After delivery date
        case 432:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'Y',
                problem_code: 'W',
                detail_code: 'FO',
                reason_code: 'IEN',
                res_code: '432',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'F',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
            // "Delivered Wrong Food Incomplete - GPT - On or After delivery date "
        case 433:
            return {
                deviceType,
                orderNumber: ROSSOrderNumber,
                user,
                ti_email: tiEmail,
                start_time: startTime,
                resolution_brand: resolutionBrand,
                msg_florist: 'N',
                problem_code: 'W',
                detail_code: 'FO',
                reason_code: 'IEN',
                res_code: '433',
                suggest_res_code: suggestResCode,
                status_code: 'X',
                fault_code: 'V',
                error_code: 'P',
                suggested_res_id: suggestedResId,
            };
        default:
            break;
    }
};

const popChat = (textType) => {
    let text1 = 'Click below to chat with the next available agent to complete replacement or refund.';
    if (textType === 'not available for replacement') {
        text1 = 'Sorry, this product is not available for replacement. Please chat with a live agent for further assistance.';
    } else if (textType === 'never delivered') {
        text1 = 'Sorry to hear that your item was never delivered. Please chat with a live agent for further assistance.';
    }
    return {
        text1,
        screenListType: ['Chat with a live agent now.'],
        btnType: 'Chat with agent',
    };
};

const getPageDetails = (currentPage, pageType, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled, ROSSOrderTotal, isQualityIssueChatFlowEnabled = false, productBrand = '', ROSSOrder) => {
    let nextPage = ''; let previousPage = ''; let text1 = ''; let text2 = ''; let text3 = ''; let btnType = ''; let
        screenListType = [];
    const {
        page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType, noDLCF,
    } = pageType;

    switch (currentPage) {
        case 'page0':
            text1 = 'What happened to the item?';
            if (['No, I need additional help.'].includes(page0ReasonType)) { // no DLCF Chat Option
                btnType = renderButtonText(page0ReasonType, isQualityIssueChatFlowEnabled, productBrand, false, noDLCF);
            } else {
                nextPage = ['never delivered', 'delivered late', 'delivered too early'].includes(page0ReasonType) ? 'page3' : 'page1';
                btnType = renderButtonText(page0ReasonType, isQualityIssueChatFlowEnabled, productBrand);
            }
            break;
        case 'page1':
            text1 = `${page0ReasonType !== 'doesn\'t look like picture' && page0ReasonType !== 'wrong item delivered' ? `Which item was ${page0ReasonType}?` : page0ReasonType === "doesn't look like picture" ? 'Which item doesn\'t look like the picture?' : 'Which item was delivered wrong?'}`;
            nextPage = 'page2';
            if (page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                screenListType = list2;
            } else if ((["doesn't look like picture", 'wrong item delivered'].includes(page0ReasonType))) {
                screenListType = list12;
            }
            break;
        case 'page2':
            text1 = 'Please tell us a little more. What was the condition of the delivered item?';
            const isWrongItemDelivered = ["doesn't look like picture", 'wrong item delivered'].includes(page0ReasonType);
            screenListType = list3;
            if (page1ReasonType === 'container (vase, pot, basket)') {
                screenListType = (isWrongItemDelivered ? list7 : list6);
            } else if (page1ReasonType === 'food (chocolate, fruit, cheese)') {
                screenListType = isWrongItemDelivered ? list11 : list8;
            } else if (page1ReasonType === 'primary item (flower, plants, gifts)') {
                screenListType = isWrongItemDelivered ? list10 : list3;
            } else if (page1ReasonType === 'card message' || page1ReasonType === 'add-ons (plush, balloon, pretzels)') {
                text1 = `Sorry to hear that your ${page1ReasonType === 'card message' ? 'card message' : 'add-on' }
                ${page0ReasonType === 'doesn\'t look like picture' && page1ReasonType !== 'card message' ? 'doesn\'t look like the picture' : page0ReasonType === 'wrong item delivered' && page1ReasonType !== 'card message' ? 'doesn\'t match what you ordered' : page1ReasonType === 'card message' ? 'doesn\'t match what you entered' : 'was delivered damaged, broken and/or spoiled'}.`;
                text2 = '';
                text3 = '';
                screenListType = ['chat with a live agent now.'];
                btnType = renderButtonText(page1ReasonType);
            }
            break;
        case 'page3':
            text1 = `${page0ReasonType !== "doesn't look like picture" && page0ReasonType !== 'wrong item delivered' ? `Sorry to hear that it was ${page0ReasonType}.` : `${page0ReasonType === "doesn't look like picture" ? "Sorry to hear that it doesn't look like the picture." : 'Sorry to hear that the wrong item was delivered.'}`}`;
            text2 = 'Let us fix this by scheduling a redelivery for the earliest available delivery date. Also, we will issue you an additional $15 Savings Pass credit for any future purchases.';
            text3 = 'How does that sound?';
            previousPage = 'page2';
            btnType = renderButtonText(page3ReasonType);
            screenListType = list4;

            if (['never delivered', 'delivered late', 'delivered too early'].includes(page0ReasonType)) {
                previousPage = 'page0';
                if (page0ReasonType === 'never delivered') {
                    const todaysDate = DDMMMYY(new Date());
                    const estimatedDeliveryDate = ROSSOrder?.items[0]?.estimatedDeliveryDate || todaysDate;
                    const deliveryDate = ROSSOrder?.items[0]?.deliveryDate || estimatedDeliveryDate;
                    const ROSSOrderDeliveryDates = DDMMMYY(deliveryDate);
                    const isOrderDeliveredOnOrBeforeDeliveryDate = (new Date(todaysDate)).getTime() <= (new Date(ROSSOrderDeliveryDates)).getTime();
                    if (isOrderDeliveredOnOrBeforeDeliveryDate && !noDLCF) {
                        const chatData = popChat('never delivered');
                        text1 = chatData.text1;
                        text2 = '';
                        text3 = '';
                        screenListType = chatData.screenListType;
                        btnType = chatData.btnType;
                    } else {
                        screenListType = list4;
                    }
                } else if (page3ReasonType === 'sounds great. Let\'s do it.') {
                    btnType = 'Next';
                }
            }

            if (page0ReasonType === 'delivered damaged, broken and/or spoiled' && productType === 'GPT') { // delivered damaged screen
                if (page2ReasonType !== 'not fresh' && page2ReasonType !== 'expired' && page2ReasonType !== 'did not last' && page2ReasonType !== 'unopened blooms') {
                    text1 = 'Did the shipping box arrive damaged?';
                    text2 = '';
                    text3 = '';
                    screenListType = list9;
                }
            } else if ((productType === 'FPT' || productType === 'GPT') && isAvailable === false) { // product not available screen
                const chatData = popChat('not available for replacement');
                text1 = chatData.text1;
                text2 = '';
                text3 = '';
                screenListType = chatData.screenListType;
                btnType = chatData.btnType;
            }

            if (!isReplacementEnabled && isPartialCreditEnabled && productType === 'FPT') { // replacement not allowed
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                text3 = '';
                screenListType = list5;
            } else if (!isPartialCreditEnabled && isReplacementEnabled && productType === 'FPT') { // partial refund not allowed
                screenListType = ['sounds great. Let\'s do it.'];
            }
            break;
        case 'page4':
            const isFPTPartialRefundFlowPointingToChat = (productType === 'FPT' && (page0ReasonType === 'doesn\'t look like picture' || page0ReasonType === 'wrong item delivered') && (page1ReasonType === 'food (chocolate, fruit, cheese)' && page2ReasonType === 'missing item' && page3ReasonType === 'No, I need additional help.')); // Savings Pass flow for this scenario does not exist so we use this to point to chat
            const isGPTPartialRefundFlowPointingToChat = (productType === 'GPT' && (page0ReasonType === 'doesn\'t look like picture' || page0ReasonType === 'wrong item delivered') && (page1ReasonType === 'primary item (flower, plants, gifts)' && page2ReasonType === 'incorrect arrangement' && page3ReasonType === 'No, I need additional help.'));
            btnType = renderButtonText(page4ReasonType);
            if (page3ReasonType === 'sounds great. Let\'s do it.') {
                if (page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') {
                    const chatData = popChat();
                    text1 = chatData.text1;
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else {
                    text1 = 'Your replacement order is being processed right now at no extra charge. You will receive an Order Confirmation email with all the details including tracking information and your $15 Savings Pass shortly.';
                    screenListType = [];
                    btnType = 'Close';
                }
            } else if (page3ReasonType === 'No, I need additional help.') {
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                screenListType = list5;
                if ((page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') && page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                    btnType = 'Next';
                }
                if ((page0ReasonType === 'wrong item delivered' || page0ReasonType === 'doesn\'t look like picture') && page1ReasonType === 'food (chocolate, fruit, cheese)' && page3ReasonType === 'No, I need additional help.' && page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                    btnType = 'Chat with agent';
                }
                if (page0ReasonType === 'never delivered' || isFPTPartialRefundFlowPointingToChat || isGPTPartialRefundFlowPointingToChat) {
                    const chatData = popChat();
                    text1 = chatData.text1;
                    text2 = '';
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                }
            } else if (page3ReasonType === 'yes' || page3ReasonType === 'no') {
                if (productType === 'GPT' && isAvailable === false) { // product not available screen
                    const chatData = popChat('not available for replacement');
                    text1 = chatData.text1;
                    text2 = '';
                    text3 = '';
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else {
                    text1 = `Sorry to hear that your item was ${page0ReasonType}.`;
                    text2 = 'Let us fix this by scheduling a redelivery for the earliest available delivery date. Also, we will issue you an additional $15 Savings Pass credit for any future purchases.';
                    text3 = 'How does that sound?';
                    screenListType = list4;
                }
            }

            if (!isReplacementEnabled && isPartialCreditEnabled && productType === 'GPT') {
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                text3 = '';
                screenListType = list5;
            } else if (!isPartialCreditEnabled && isReplacementEnabled && productType === 'GPT') {
                screenListType = ['sounds great. Let\'s do it.'];
            }

            break;
        case 'page5':
            btnType = 'Close';
            if (page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                if (page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') {
                    const chatData = popChat();
                    text1 = chatData.text1;
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else if ((page0ReasonType === 'wrong item delivered' || page0ReasonType === 'doesn\'t look like picture') && page1ReasonType === 'food (chocolate, fruit, cheese)' && page3ReasonType === 'No, I need additional help.' && page4ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                    break;
                } else {
                    text1 = 'Your 50% refund will be processed and applied to your original payment method within 10 business days, and a $15 Savings Pass will be emailed to you shortly.';
                    text2 = 'We sincerely apologize for the inconvenience.';
                }
            } else if (page4ReasonType === 'sounds great. Let\'s do it.') {
                if (page0ReasonType === 'never delivered' || page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') {
                    const chatData = popChat();
                    text1 = chatData.text1;
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else {
                    text1 = 'Your replacement order is being processed right now at no extra charge. You will receive an Order Confirmation email with all the details including tracking information and your $15 Savings Pass shortly.';
                }
            } else if (page4ReasonType === 'No, I need additional help.') {
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                screenListType = list5;
                btnType = renderButtonText(page5ReasonType);
                if ((page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') && page5ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                    btnType = 'Next';
                }
            }
            break;
        case 'page6':
            if (page5ReasonType === 'issue a 50% refund, and a $15 Savings Pass credit.') {
                text1 = 'Your 50% refund will be processed and applied to your original payment method within 10 business days, and a $15 Savings Pass will be emailed to you shortly.';
            }
            break;
        default:
            nextPage = '';
            previousPage = '';
            text1 = '';
            text2 = '';
            text3 = '';
            btnType = '';
            screenListType = [];
            break;
    }
    const details = {
        text1,
        text2,
        text3,
        nextPage,
        previousPage,
        btnType,
        screenListType,
    };
    return details;
};

const getFoodBrandPageDetails = (currentPage, pageType, productType, isAvailable, isReplacementEnabled, isPartialCreditEnabled, ROSSOrderTotal, isPaidShpping) => {
    let nextPage = ''; let previousPage = ''; let text1 = ''; let text2 = ''; let text3 = ''; let btnType = ''; let
        screenListType = [];
    const {
        page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType, isHDQualityIssueChatFlowEnabled, productBrand, isHDReplacementRoutingToAgent,
    } = pageType;
    const orderTotalPrice = ROSSOrderTotal ? Number(ROSSOrderTotal).toFixed(2) : 0.00; // full refund
    switch (currentPage) {
        case 'page0':
            text1 = 'What happened to the item?';
            nextPage = ['never delivered', 'delivered late', 'delivered too early'].includes(page0ReasonType) ? 'page3' : 'page1';
            if (page0ReasonType === 'doesn\'t look like picture') {
                nextPage = 'page7';
                screenListType = [];
            }
            btnType = renderButtonText(page0ReasonType, isHDQualityIssueChatFlowEnabled, productBrand);
            break;
        case 'page1':
            previousPage = 'page0';
            btnType = renderButtonText(page1ReasonType);
            nextPage = 'page2';
            if (page0ReasonType === 'doesn\'t look like picture') {
                text1 = 'Which item didn\'t meet expectations?';
                screenListType = list15;
                previousPage = 'page7';
            } else if (page0ReasonType === 'wrong item delivered') {
                text1 = 'Which item was delivered wrong?';
                nextPage = 'page3';
                screenListType = list19;
            } else if (page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                text1 = `Which item was ${page0ReasonType} ?`;
                screenListType = list15;
            }
            break;

        case 'page2':
            text1 = 'Please tell us a little more. What was the condition of the delivered item?';
            btnType = renderButtonText(page2ReasonType);
            if (page1ReasonType === 'primary item (flowers, plants, gift baskets, gifts)' && page0ReasonType === 'doesn\'t look like picture') {
                screenListType = list16;
            } else if (page1ReasonType === 'primary item (flowers, plants, gift baskets, gifts)' && page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                screenListType = list20;
            } else if (page1ReasonType === 'container (vase, pot, basket)' && page0ReasonType === 'doesn\'t look like picture') {
                screenListType = list17;
            } else if (page1ReasonType === 'container (vase, pot, basket)' && page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                screenListType = list22;
            } else if (page1ReasonType === 'food (food gift baskets, chocolate, fruit, cheese, wine)' && page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                screenListType = list21;
            } else if ((page1ReasonType === 'food (food gift baskets, chocolate, fruit, cheese, wine)' || page1ReasonType === 'add-ons (wine, cider, chocolate, Moose Munch)') && page0ReasonType === 'doesn\'t look like picture') {
                screenListType = list18;
            } else if (page1ReasonType === 'add-ons (wine, cider, chocolate, Moose Munch)' && page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                screenListType = list23;
            }
            break;
        case 'page3':
            text1 = 'Sorry to hear that your item didn\'t meet expectations.';
            text2 = 'Let us fix this by scheduling a redelivery for the earliest available delivery date.';
            text3 = 'How does that sound?';
            previousPage = 'page2';
            screenListType = list4;
            btnType = renderButtonText(page3ReasonType, null, productBrand, isHDReplacementRoutingToAgent);

            if (['never delivered', 'delivered late', 'delivered too early'].includes(page0ReasonType)) {
                text1 = `Sorry to hear that your item was ${page0ReasonType}.`;
                previousPage = 'page0';
            }

            if (page0ReasonType === 'wrong item delivered') {
                text1 = 'Sorry to hear that the wrong item was delivered.';
                previousPage = 'page1';
                if (page1ReasonType === 'gift message') {
                    text1 = 'Sorry to hear that there was a mistake with the delivered gift message.';
                    text2 = 'Let us fix this by connecting you with the next available agent.';
                    screenListType = ['chat with a live agent now.'];
                }
            } else if (page0ReasonType === 'delivered late' || page0ReasonType === 'delivered too early') {
                text2 = isPaidShpping ? 'Let us fix this by connecting you to a live agent to refund your shipping fee.' // IF CUSTOMER PAID FOR SHIPPING:
                    : 'Let us fix this by connecting you to a live agent to issue a 20% refund of the cost of this item.'; // IF CUSTOMER DID NOT PAY FOR SHIPPING:
                if (page3ReasonType === 'sounds great. Let\'s do it.') {
                    btnType = 'Chat with agent';
                }
            } else if (page0ReasonType === 'delivered damaged, broken and/or spoiled') {
                text1 = 'Sorry to hear that your item was delivered damaged, broken, and/or spoiled.';
                text2 = 'Was more than 50% of the item delivered damaged, broken, and/or spoiled?';
                text3 = '';
                screenListType = ['No, less than 50%.', 'Yes, more than 50%.'];
            }

            if (page3ReasonType === 'sounds great. Let\'s do it.' && isAvailable === false) {
                btnType = 'Next';
            }
            break;
        case 'page4':
            btnType = (page3ReasonType === 'No, less than 50%.' && page4ReasonType === 'sounds great. Let\'s do it.') ? 'Chat with agent' : renderButtonText(page4ReasonType, null, productBrand, isHDReplacementRoutingToAgent);
            if (page3ReasonType === 'sounds great. Let\'s do it.') {
                if (isAvailable === false) {
                    const chatData = popChat('not available for replacement');
                    text1 = chatData.text1;
                    text2 = '';
                    text3 = '';
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else {
                    text1 = 'Your replacement order is being processed right now at no extra charge.';
                    screenListType = [];
                    btnType = 'Close';
                }
            } else if (page3ReasonType === 'No, I need additional help.') {
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                screenListType = list14;
                if (page0ReasonType === 'delivered too early') {
                    screenListType = list24;
                    btnType = 'Chat with agent';
                }
            } else if (page3ReasonType === 'No, less than 50%.' || page3ReasonType === 'Yes, more than 50%.') {
                text1 = 'Let us fix this by scheduling a redelivery for that specific damaged item for the earliest available delivery date.';
                text2 = 'How does that sound?';
                screenListType = list4;
                if (page3ReasonType === 'Yes, more than 50%.' && page4ReasonType === 'sounds great. Let\'s do it.' && isAvailable === false) {
                    btnType = 'Next';
                }
            }
            break;
        case 'page5':
            btnType = 'Close';
            if (page4ReasonType === 'issue a full refund.') {
                text1 = `Your refund of $${orderTotalPrice} will be processed and applied to your original payment method within 10 business days.`;
                text2 = 'We sincerely apologize for the inconvenience.';
            } else if (page4ReasonType === 'sounds great. Let\'s do it.' && page3ReasonType !== 'No, less than 50%.') {
                if (isAvailable === false) {
                    const chatData = popChat('not available for replacement');
                    text1 = chatData.text1;
                    text2 = '';
                    text3 = '';
                    screenListType = chatData.screenListType;
                    btnType = chatData.btnType;
                } else {
                    text1 = 'Your replacement order is being processed right now at no extra charge.';
                }
            } else if (page4ReasonType === 'No, I need additional help.') {
                text1 = 'We understand how frustrating this situation is, and we sincerely apologize for the inconvenience.';
                text2 = 'How can we make it right?';
                screenListType = list14;
                btnType = (page5ReasonType === 'issue a full refund.' && page3ReasonType === 'No, less than 50%.') ? 'Chat with agent' : renderButtonText(page5ReasonType);
            }
            break;
        case 'page6':
            if (page5ReasonType === 'issue a full refund.') {
                text1 = `Your refund of $${orderTotalPrice} will be processed and applied to your original payment method within 10 business days.`;
                text2 = 'We sincerely apologize for the inconvenience.';
            }
            break;
        case 'page7':
            if (page0ReasonType === 'doesn\'t look like picture') {
                text1 = 'We may have substituted an item in your gift or the container it arrived in to ensure it arrived on time.';
                text2 = 'The value of the substitution should he equal to or greater than the value of the pictured item.';
                nextPage = 'page1';
            }
            break;
        default:
            nextPage = '';
            previousPage = '';
            text1 = '';
            text2 = '';
            text3 = '';
            btnType = '';
            screenListType = [];
            break;
    }
    const details = {
        text1,
        text2,
        text3,
        nextPage,
        previousPage,
        btnType,
        screenListType,
    };
    return details;
};

const ReplacementHelper = {
    noDLCFList,
    list1,
    list2,
    list3,
    list4,
    list5,
    list6,
    list7,
    list8,
    list9,
    list10,
    list11,
    list12,
    list13,
    getPageDetails,
    getFoodBrandPageDetails,
    renderButtonText,
    checkIsMoreThan7Days,
    handleResCode,
    generateResCodePayload,
    handleResolutionSelection,
    generateAgentMessage,
};

export default ReplacementHelper;
